import StackAPI from '@/lib/StackAPI'
import { DTOSaleData } from '../functions/DTOSale'
import { SaleData } from '../types/Sale'
import { currentRole } from '@/authProvider'
import { ParsedSaleData } from '../types/ParsedObjects'

const getSales = async (id: string): Promise<ParsedSaleData> => {
  const partnerRole = currentRole()

  const { data: saleData } = await StackAPI().get<SaleData>({
    path: `partners/sales/${id}`,
    params: { context: partnerRole.type }
  })

  const parsedSaleData = DTOSaleData(saleData)

  return parsedSaleData
}

export { getSales }
